import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import { useUserSearch } from "hooks/citajteo/user/useUserSearch";
import { User } from "type/user/user.type";

const Users: React.FC = () => {
  const users = useUserSearch();

  return (
    <div>
      <NewItem>
        <RouterLink to="/admin-dashboard/dl-group-edit">novo</RouterLink>
      </NewItem>

      {users &&
        users.items.length > 0 &&
        users.items.map((item: User) => (
          <ListItem key={`user_${item.id}`}>
            <RouterLink to={`/admin-dashboard/user-edit/${item.id}`}>
              polja
            </RouterLink>
            <br />
            {item.un}
            <DeleteText>obriši</DeleteText>
          </ListItem>
        ))}
    </div>
  );
};

export default Users;

const NewItem = styled.div`
  margin-top: 0;
`;

const ListItem = styled.div`
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;

const DeleteText = styled.span`
  margin-left: 3%;
  cursor: pointer;
  color: darkgrey;
`;
